module.exports = __webpack_public_path__ + "ed4ff817838a5211ef64619c5ad7e1e4.pdf";